import { Divider } from '@advanza/ui'
import PartnerPushList from 'components/partnerPush/PartnerPushList'
import Page from 'components/ui/Page'

const PartnerPushPage = () => (
    <Page title="Partner request push">
        <div className="container">
            <Divider />
            <h1>Partner request push</h1>
            <p>
                Outbound HTTPS POST when the configured provider receives a lead. Franchise main
                accounts also receive the leads of their sub-accounts, identified by business name.
                Not the provider Zapier integration under Settings → Apis. The shared secret is
                shown once after create. While a subscription is enabled the account counts as
                API-connected: leads show as request sent instead of no response, and reminders are
                suppressed. The lead mail toggle decides whether the provider still gets the normal
                lead mail on top of the webhook.
            </p>
            <PartnerPushList />
        </div>
    </Page>
)

export default PartnerPushPage
